import { DataPromise, Destination, GraphError, IGraphArrayPayload, IGraphPayload } from '../context/AxiosContext'
import useEntity from '../hooks/useEntity'
import { MailFolder } from '@microsoft/microsoft-graph-types'

// noinspection JSUnusedGlobalSymbols
export default function useEmailFolders(): [
    DataPromise<string, undefined, GraphError>,
    DataPromise<Map<string, MailFolder>, undefined, GraphError>,
] {
    const [rootFolderId] = useEntity<string, IGraphPayload<MailFolder>, GraphError>(
        () => ({ url: '/mailFolders/msgfolderroot', baseURL: Destination.Email, params: { $select: 'id' } }),
        false,
        result => result.data.id,
    )
    const [folders] = useEntity<Map<string, MailFolder>, IGraphArrayPayload<MailFolder>, GraphError>(
        () => ({
            url: '/mailFolders/delta',
            baseURL: Destination.Email,
            headers: {
                // This endpoint does not support the $top parameter.
                // @see https://docs.microsoft.com/en-us/graph/delta-query-messages#optional-request-header
                Prefer: 'odata.maxpagesize=1000',
                // Reduce the amount of data we're downloading by omitting OData metadata.
                // @see https://stackoverflow.com/a/70982860/862825
                Accept: 'application/json;odata.metadata=none',
            },
            params: { $select: 'id,displayName,parentFolderId', includeHiddenFolders: true },
        }),
        false,
        // Create a map of all folders by ID, so we can easily locate them.
        result =>
            result.data.value.reduce(
                (map: Map<string, MailFolder>, folder: MailFolder) => map.set(folder.id, folder),
                new Map<string, MailFolder>(),
            ),
    )

    return [rootFolderId, folders]
}
